
















import Vue from "vue";
import { Etablissement } from "../../../models/Etablissement";
export default Vue.extend({
  props: {
    etablissement: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    getIcon(etablissement: Etablissement): string {
      let icone: any = {};
      // Icones des etablissements
      icone[
        "ICON_1"
      ] = require(`@/assets/etablissement/1_etablissement_jaune.svg`);
      icone[
        "ICON_2"
      ] = require(`@/assets/etablissement/2_etablissement_bleu.svg`);
      icone[
        "ICON_3"
      ] = require(`@/assets/etablissement/3_etablissement_vert.svg`);
      icone[
        "ICON_4"
      ] = require(`@/assets/etablissement/4_etablissement_rouge.svg`);

      return (
        icone[etablissement.getIcon()] ||
        require(`@/assets/etablissement/2_etablissement_bleu.svg`)
      );
    },
  },
});
